export default {
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success"
};
